import api from '../../../api/client';
// src/views/EmployeeDashboard.js
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ProgressBar,
  Button,
  Badge,
  Image,
} from "react-bootstrap";
import { FaCalendarAlt, FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";
import config from "../../../config";
import axios from "axios";
import MainCard from "../../../components/Card/MainCard";
import { Link } from "react-router-dom";
import WeatherDisplay from "../../../components/WeatherDisplay";
import FarmDashboard from "../FarmDashboard";

const EmployeeDashboard = () => {
  const [employee, setEmployee] = useState(null);
  const [payslips, setPayslips] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const account = useSelector((state) => state.account.user);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const [summary, setSummary] = useState({});

  const userId = account.id;

  // Mock data - in a real app, this would come from API
  useEffect(() => {
    // Simulate API loading
    setTimeout(() => {
      setEmployee({
        id: "EMP001",
        name: "Alex Johnson",
        position: "Senior Developer",
        department: "Engineering",
        email: "alex.johnson@company.com",
        phone: "+1 (555) 123-4567",
        hireDate: "2020-03-15",
        profilePic: null,
        completedTasks: 78,
        pendingTasks: 5,
        overdueTasks: 2,
      });

      setPayslips([
        {
          id: "PSL001",
          date: "2023-10-31",
          amount: 4500.0,
          status: "Paid",
          downloadUrl: "#",
        },
        {
          id: "PSL002",
          date: "2023-09-30",
          amount: 4500.0,
          status: "Paid",
          downloadUrl: "#",
        },
        {
          id: "PSL003",
          date: "2023-08-31",
          amount: 4500.0,
          status: "Paid",
          downloadUrl: "#",
        },
        {
          id: "PSL004",
          date: "2023-07-31",
          amount: 4500.0,
          status: "Paid",
          downloadUrl: "#",
        },
      ]);

      setUpcomingEvents([
        {
          id: "EVT001",
          title: "Team Meeting",
          date: "2023-11-15 10:00",
          type: "Meeting",
        },
        {
          id: "EVT002",
          title: "Project Deadline",
          date: "2023-11-20 17:00",
          type: "Deadline",
        },
        {
          id: "EVT003",
          title: "Company Workshop",
          date: "2023-11-25 09:00",
          type: "Training",
        },
      ]);

      setNotifications([
        {
          id: "NOT001",
          message: "You have a new task assigned",
          time: "2 hours ago",
          read: false,
        },
        {
          id: "NOT002",
          message: "Your payslip for October is available",
          time: "1 day ago",
          read: true,
        },
        {
          id: "NOT003",
          message: "Team meeting scheduled for tomorrow",
          time: "1 day ago",
          read: true,
        },
      ]);
    }, 500);
  }, []);

  const handleMarkAsRead = (id) => {
    setNotifications(
      notifications.map((notif) =>
        notif.id === id ? { ...notif, read: true } : notif,
      ),
    );
  };

  useEffect(() => {
    axios
      .get(`/dashboard/events-summary`, {
        params: { userId },
      })
      .then((res) => {
        // console.log(res.data);
        setSummary(res.data.summary);
      });
  }, []);

  if (!account) {
    return (
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading your dashboard...</p>
        </div>
      </Container>
    );
  }

  return (
    <>
      {/* Main Content */}
      {/* <div className="dashboard-content">
        <div className="dashboard-main">
          <Row>
            <Col lg={8}>
              <Row>
                <Col md={12}>
                  <Card className="mb-4">
                    <Card.Header>
                      <h5 className="mb-0">Performance Metrics</h5>
                    </Card.Header>
                    <Card.Body>
                      <div className="d-flex justify-content-around text-center mb-4">
                        <div>
                          <h2 className="text-primary">78%</h2>
                          <p className="text-muted">Task Completion</p>
                        </div>
                        <div>
                          <h2 className="text-success">92%</h2>
                          <p className="text-muted">On-time Delivery</p>
                        </div>
                        <div>
                          <h2 className="text-info">4.8</h2>
                          <p className="text-muted">Avg. Rating</p>
                        </div>
                      </div>

                      <div className="analytics-chart-placeholder p-5 text-center bg-light rounded">
                        <h5 className="text-muted">Performance Chart</h5>
                        <p className="text-muted">
                          Visualization of performance metrics over time
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <Card className="mb-4">
                    <Card.Header>
                      <h5 className="mb-0">Goals</h5>
                    </Card.Header>
                    <Card.Body>
                      <div className="goal-item mb-3">
                        <div className="d-flex justify-content-between mb-1">
                          <span>Complete Certification</span>
                          <span>65%</span>
                        </div>
                        <ProgressBar now={65} variant="info" />
                      </div>

                      <div className="goal-item mb-3">
                        <div className="d-flex justify-content-between mb-1">
                          <span>Team Collaboration</span>
                          <span>85%</span>
                        </div>
                        <ProgressBar now={85} variant="success" />
                      </div>

                      <div className="goal-item">
                        <div className="d-flex justify-content-between mb-1">
                          <span>Skill Development</span>
                          <span>45%</span>
                        </div>
                        <ProgressBar now={45} variant="warning" />
                      </div>

                      <Button variant="outline-primary" className="mt-3 w-100">
                        Set New Goals
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    <Card.Header>
                      <h5 className="mb-0">Peer Feedback</h5>
                    </Card.Header>
                    <Card.Body>
                      <div className="feedback-item mb-3 p-3 border rounded">
                        <div className="d-flex justify-content-between mb-2">
                          <span className="fw-bold">John Smith</span>
                          <small className="text-muted">2 days ago</small>
                        </div>
                        <p className="mb-0">
                          "Alex did an excellent job on the recent project. His
                          attention to detail was impressive."
                        </p>
                      </div>

                      <div className="feedback-item p-3 border rounded">
                        <div className="d-flex justify-content-between mb-2">
                          <span className="fw-bold">Sarah Johnson</span>
                          <small className="text-muted">1 week ago</small>
                        </div>
                        <p className="mb-0">
                          "Great collaboration on the client presentation.
                          Alex's technical expertise was invaluable."
                        </p>
                      </div>

                      <Button
                        variant="outline-secondary"
                        className="mt-3 w-100"
                      >
                        Request Feedback
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>

            <Col lg={4}>
              <Card className="mb-4">
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Latest Events</h5>
                  <Badge bg="primary">
                    {Object.values(summary).flat().length}
                  </Badge>
                </Card.Header>

                <Card.Body>
                  <div className="events-list">
                    {summary &&
                      Object.entries(summary)?.map(([status, event]) => (
                        <>
                          <ul className="space-y-3">
                            <span className="text-capitalize">{`${status} ${event.eventType}`}</span>
                            <li>
                              <div className="font-semibold d-flex justify-content-between">
                                <h6>{event?.title}</h6>
                                <div className="text-sm text-muted">
                                  <small>
                                    {new Date(
                                      event.fromDate,
                                    ).toLocaleDateString()}{" "}
                                    →{" "}
                                    {new Date(
                                      event.toDate,
                                    ).toLocaleDateString()}
                                  </small>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </>
                      ))}
                  </div>

                  <Button variant="outline-primary" className="w-100 mt-3">
                    <Link to={`/calendar/events`}>View All Events</Link>
                  </Button>
                </Card.Body>
              </Card>
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Notifications</h5>
                  <Badge bg="danger">
                    {notifications.filter((n) => !n.read).length} new
                  </Badge>
                </Card.Header>
                <Card.Body>
                  <div className="notifications-list">
                    {notifications.map((notif) => (
                      <div
                        key={notif.id}
                        className={`notification-item mb-3 p-3 border rounded ${
                          !notif.read ? "bg-light" : ""
                        }`}
                      >
                        <div className="d-flex justify-content-between">
                          <p className="mb-1">{notif.message}</p>
                          {!notif.read && (
                            <Button
                              variant="link"
                              size="sm"
                              onClick={() => handleMarkAsRead(notif.id)}
                            >
                              Mark as read
                            </Button>
                          )}
                        </div>
                        <small className="text-muted">{notif.time}</small>
                      </div>
                    ))}
                  </div>
                  <Button variant="outline-secondary" className="w-100">
                    View All Notifications
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div> */}
      <FarmDashboard />
    </>
  );
};

export default EmployeeDashboard;
